import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { SpinnerService } from 'src/app/components/spinner-component/spinner.service';
import { RestService } from 'src/app/services/rest-service';
import { AppSettings } from 'src/app/shared/app-settings';
import { Title } from '@angular/platform-browser';
import { SolarScriptDialogComponent } from '../solar-script/solar-script-dialog/solar-script-dialog.component';
import { MdcDataComponent } from '../mdc-data/mdc-data.component';

@Component({
  selector: 'app-x3-health-monitoring',
  templateUrl: './x3-health-monitoring.component.html',
  styleUrls: ['./x3-health-monitoring.component.css'],
  standalone: true,
  imports: [CommonModule, SolarScriptDialogComponent, MdcDataComponent]
})
export class X3HealthMonitoringComponent implements OnInit {
  @Output() showDeviceInfoEmit = new EventEmitter();
  @Input() deviceInfoDataObj: any;
  displayStyle1: string = 'none';
  displayStyle2: string = 'none';
  healthMonitoringFilteredDataMessage: string = 'Loading ...';
  monitoringDataMessage:string = 'Loading ...';
  mdcDataMessage:string = 'Loading ...';
  public healthMonitoringData: Array<any> = [];
  public healthMonitoringFilteredData: Array<any> = [];
  public monitoringData: Array<any> = [];
  public mdcDataFiltered: Array<any> = [];
  public loading: boolean = false;
  public monitoringLoading: boolean = false;
  public x310DetailsLoading: boolean = false;
  public mdcLoading:boolean = false;
  public p: number = 1;
  public p1: number = 1;
  public perPageItems: number = 10;
  public chartsData: any = {
    data: [0, 0, 0],
    labels: ['UP', 'SSR', 'DOWN'],
  };
  public x410ChartData: any = {
    data: [0, 0, 0],
    labels: ['UP', 'SSR', 'DOWN'],
  };
  public pieChartType: any = 'doughnut';
  public chartColors: any[] = [{ backgroundColor: ["#008000", "#6f87d8", "#bf1b00"], borderColor: ['#FFFFFF', '#FFFFFF', '#FFFFFF', "#FFFFFF"], borderWidth: '3px' }];
  public pieChartOptions: any = {
    responsive: true,
    cutoutPercentage: 83,
    layout: {
      padding: 5,
    },
    legend: {
      display: true,
      position: 'right',
      align: 'left',
      labels: {
        usePointStyle: true,
        fontSize: 12,
        // fontFamily: "Work Sans",
        // boxWidth: 8,
        fontColor: '#fff',
      },
    },
    maintainAspectRatio: true,
    tooltips: {
      mode: 'index',
      intersect: true,
      titleFontSize: 9,
      bodyFontSize: 14,
      callbacks: {
        label: function (tooltipItem, data) {
          let sum = 0;

          var allData = data.datasets[tooltipItem.datasetIndex].data;
          allData.map((data) => {
            sum += data;
          });
          var tooltipLabel = data.labels[tooltipItem.index];
          var tooltipData = allData[tooltipItem.index];
          let percentage =
            ((allData[tooltipItem.index] * 100) / sum).toFixed(2) + '%';
          return tooltipLabel + ': ' + tooltipData + '(' + percentage + ')';
        },
      },
    },
    plugins: {
      labels: {
        render: 'value',
      },
    },
  };
  public ascDsc: boolean = true;
  public filterValue: any = null;
  public filterMDCValue: any = null;
  public metricsData: any = null;
  public metricsDetails: boolean = false;
  public mdcDetails: boolean = false;
  public metricsTabSelected: boolean = true;
  public detailsTabSelected: boolean = false;
  public mdcTabSelected: boolean = false;
  totalCount: any = null;
  solarTotalCount: any = null;
  x410data: any = null;
  x310data: any = null;
  x310dataTotal: any;
  x410dataTotal: any;
  x310dataSolarCount: any;
  x410dataSolarCount: any;
  selectedSite: any;
  sitesData: any;
  mdcData: any[] = [];
  mdcFullData: any[] = [];
  @Input() mdcMetadata: any;
  constructor(
    private titleService: Title,
    public spinner: SpinnerService,
    private toastr: ToastrService,
    public restService: RestService
  ) {
    // this.titleService.setTitle("X3 Health Monitoring");
  }

  ngOnInit(): void {
    this.loading=true;
    this.getHealthMonitoringMetrics();
    this.getHealthMonitoringData();
    this.getMDCdata();
    let title = this.titleService.getTitle();
  }

  public showMetricsTab(): void {
    this.metricsTabSelected = true;
    this.detailsTabSelected = false;
    this.mdcTabSelected = false;
  }

  // Function to show the details tab
  public showDetailsTab(): void {
    this.metricsTabSelected = false;
    this.detailsTabSelected = true;
    this.mdcTabSelected = false;
  }

  // Function to show the MDC tab
  public showMDCTab(): void {
    this.metricsTabSelected = false;
    this.detailsTabSelected = false;
    this.mdcTabSelected = true;
  }

  /**
   * getHealthMonitoringMetrics
   */
  public getHealthMonitoringMetrics() {
    this.monitoringData = [];
    this.monitoringLoading = true;
    this.spinner.activate();
    this.restService.getRequest(AppSettings.X310METRICS, '').subscribe(
      (response) => {
        this.monitoringData = response;
        this.monitoringLoading = false;
        this.monitoringDataMessage = '';
        if(this.monitoringData?.length == 0){
          this.monitoringDataMessage = 'No data found';
        }
        if (this.monitoringData && this.monitoringData.length > 0) {
          for (let i = 0; i < this.monitoringData.length; i++) {
            if (this.monitoringData[i]['type'] === 'X310') {
              this.x310data = this.monitoringData[i];
              this.x310dataTotal = this.monitoringData[i].totalCount;
              this.x310dataSolarCount = this.monitoringData[i].solarTotalCount;
              this.chartsData['data'][0] = this.monitoringData[i]['upCount'];
              this.chartsData['data'][1] = this.monitoringData[i]['solarCount'];
              this.chartsData['data'][2] = this.monitoringData[i]['downCount'];
            } else if (this.monitoringData[i]['type'] === 'X410') {
              this.x410data = this.monitoringData[i];
              this.x410dataTotal = this.monitoringData[i].totalCount;
              this.x410dataSolarCount = this.monitoringData[i].solarTotalCount;
              this.x410ChartData['data'][0] = this.monitoringData[i]['upCount'];
              this.x410ChartData['data'][1] = this.monitoringData[i]['solarCount'];
              this.x410ChartData['data'][2] = this.monitoringData[i]['downCount'];
            }
            this.totalCount = this.totalCount + this.monitoringData[i]['totalCount'];
            this.solarTotalCount =
              this.solarTotalCount + this.monitoringData[i]['solarTotalCount'];
          }
        }
        this.metricsData = this.monitoringData;
      },
      (err) => {
        this.spinner.deactivate();
        this.monitoringLoading = false;
        if (
          err &&
          err.error &&
          err.error.message &&
          err.error.message.length > 0
        ) {
          this.toastr.error(err.error.message, 'Error');
        } else {
          this.toastr.error('Session Expired Please login again.', 'Error');
        }
      }
    );
  }

  public getHealthMonitoringData() {
    this.healthMonitoringData = [];
    this.x310DetailsLoading = true;
    this.spinner.activate();
    this.restService.getRequest(AppSettings.X3HEALTHMONITORING, '').subscribe(
      (response) => {
        this.healthMonitoringData = response.data;
        this.healthMonitoringFilteredData = response.data;
        this.x310DetailsLoading = false;
        this.healthMonitoringFilteredDataMessage = '';
        if (this.healthMonitoringData?.length == 0) {
          this.healthMonitoringFilteredDataMessage = 'No data found';
        }
      },
      (err) => {
        this.spinner.deactivate();
        this.x310DetailsLoading = false;
        if (
          err &&
          err.error &&
          err.error.message &&
          err.error.message.length > 0
        ) {
          this.toastr.error(err.error.message, 'Error');
        } else {
          this.toastr.error('Session Expired Please login again.', 'Error');
        }
      }
    );
  }

  getMDCdata() {
    this.mdcData = [];
    this.mdcFullData = [];
    this.mdcLoading = true;
    this.spinner.activate();
    this.restService.getRequest(AppSettings.MDC_DEVICES, '').subscribe((response) => {
        this.mdcData = response;
        this.mdcFullData = response;
        this.mdcDataFiltered = response;
        this.mdcLoading = false;
        this.mdcDataMessage = '';
        if(this.mdcDataFiltered.length == 0){
          this.mdcDataMessage = 'No data found';
        }
      },(err)=>{
        this.spinner.deactivate();
        this.mdcLoading = false;
        if (
          err &&
          err.error &&
          err.error.message &&
          err.error.message.length > 0
        ) {
          this.toastr.error(err.error.message, 'Error');
        } else {
          this.toastr.error('Failed to get the data from API, Please try it again.', 'Error');
        }
      }
    );
  }


  /**
   * Sort Items based on asc/dsc
   * @param key
   */
  sortItems(key: any) {
    if (this.ascDsc) {
      this.healthMonitoringFilteredData = this.healthMonitoringFilteredData.sort((a, b) => {
        if (a[key] === undefined || a[key] === null) return 1;
        if (b[key] === undefined || b[key] === null) return -1;
        if (a[key] === b[key]) return 0;
        return a[key].toString().toLowerCase() < b[key].toString().toLowerCase() ? -1 : 1;
      });
    } else {
      this.healthMonitoringFilteredData = this.healthMonitoringFilteredData.sort((a, b) => {
        if (a[key] === undefined || a[key] === null) return 1;
        if (b[key] === undefined || b[key] === null) return -1;
        if (a[key] === b[key]) return 0;
        return a[key].toString().toLowerCase() > b[key].toString().toLowerCase() ? -1 : 1;
      });
    }
    this.ascDsc = !this.ascDsc;
  }

  /**
   * filterData
   */
  public filterData() {
    this.p = 1;
    this.healthMonitoringFilteredDataMessage = 'Loading ...';
    if (this.filterValue) {
      this.getByValue4(this.healthMonitoringData, this.filterValue);
    } else {
      this.healthMonitoringFilteredData = [...this.healthMonitoringData];
    }
    if (this.healthMonitoringFilteredData.length == 0) {
      this.healthMonitoringFilteredDataMessage = 'No data found';
    } else {
      this.healthMonitoringFilteredDataMessage = '';
    }
  }

  searchMDC(arr, value){
    let o;
    let newArray = [];
    this.mdcData = [];
    this.p = 1;
    if (!value || value.trim() === '') {
      newArray = [...arr];
    } else {
    for (let i = 0; i < arr.length; i++) {
      
        o = arr[i];
        let found = false;
        for (let p in o) {
          if (o.hasOwnProperty(p) && o[p] && value) {
            if (o[p].toString().toLocaleLowerCase().includes(value.toString().toLocaleLowerCase())) {
              found = true;
              break;
            }
          }
        }
        if (found) {
          newArray.push(o);
        }
      }
    }
    if (newArray && newArray.length < 1) {
      this.mdcDataMessage = 'No data found.';
    } else {
      this.mdcDataMessage = '';
    }
    this.mdcData = newArray;
    this.mdcDataFiltered = [...this.mdcData];
  }

  public filterMDCData() {
    this.p1 = 1;
    this.mdcDataMessage = 'Loading...';
    if (this.filterMDCValue) {
      this.searchMDC(this.mdcFullData, this.filterMDCValue);
    } else {
      this.mdcData = [...this.mdcFullData];
      this.mdcDataFiltered = [...this.mdcData];
    }

    if (this.mdcDataFiltered.length == 0) {
      this.mdcDataMessage = 'No data found';
    } else {
      this.mdcDataMessage = '';
    }
  }

  sortMDCItems(key: any) {
    if (this.ascDsc) {
      this.mdcDataFiltered = this.mdcData.sort((a, b) => {
        if (a[key] === undefined || a[key] === null) return 1;
        if (b[key] === undefined || b[key] === null) return -1;
        if (a[key] === b[key]) return 0;
        return a[key].toString().toLowerCase() < b[key].toString().toLowerCase() ? -1 : 1;
      });
    } else {
      this.mdcDataFiltered = this.mdcDataFiltered.sort((a, b) => {
        if (a[key] === undefined || a[key] === null) return 1;
        if (b[key] === undefined || b[key] === null) return -1;
        if (a[key] === b[key]) return 0;
        return a[key].toString().toLowerCase() > b[key].toString().toLowerCase() ? -1 : 1;
      });
    }
    this.ascDsc = !this.ascDsc;
  }

  getByValue4(arr, value) {
    let o;
    let newArray = [];
    this.healthMonitoringFilteredData = [];
    this.p = 1;
    const uniqueObjects = new Set();
    for (let i = 0, iLen = arr.length; i < iLen; i++) {
      o = arr[i];

      for (let p in o) {
        if (o.hasOwnProperty(p) && o[p] && value) {
          if (o[p].toString().toLocaleLowerCase().includes(value.toString().toLocaleLowerCase())) {
            if (!uniqueObjects.has(o)) { 
            newArray.push(o);
            this.healthMonitoringFilteredData.push(o);
            uniqueObjects.add(o);
            }
          }
        }
      }
    }
    if (
      this.healthMonitoringFilteredData &&
      this.healthMonitoringFilteredData.length < 0
    ) {
      this.healthMonitoringFilteredDataMessage = 'No data found';
    } else {
      this.healthMonitoringFilteredDataMessage = '';
    }
    // return newArray;
  }

  /**
   * downloadExcel
   */
  public downloadExcel() {
    let data = this.formatExcelData();
    if (data) {
      this.restService.downloadX310X410Data(data, 'X310X410Data');
    }
  }

  public downloadMdcExcel(){
    let data = this.formatMdcExcelData();
    if(data){
      this.restService.downloadMdcData(data,'MDCdetails');
    }
  }

  private formatExcelData() {
    let data = this.healthMonitoringData;
    let searchTerm = this.filterValue ? this.filterValue : '';
    if(searchTerm){
      searchTerm= searchTerm.toLowerCase();
    }
    let formattedData: Array<any> = [];
    if (data && data.length > 0) {
      for (let i = 0; i < data.length; i++) {
        let item = data[i];
        if(item['potentialId'].toLowerCase().includes(searchTerm)|| 
        item['siteName'].toLowerCase().includes(searchTerm) ||
        item['type'].toLowerCase().includes(searchTerm)){
        formattedData.push({
          potentialId: item['potentialId'] ? item['potentialId'] : 'N/A',
          siteName: item['siteName'] ? item['siteName'] : 'N/A',
          type: item['type'] ? item['type'] : 'N/A',
          status: item['status'] ? item['status'] : 'N/A',
          solarState: (item['solarState'] == true || item['solarState'] == false) ? item['solarState'] : 'N/A',
          lineVoltage: (item['lineVoltage'] == 1) ? 'ON' : (item['lineVoltage'] == 0) ? 'OFF' : 'N/A',
          batteryVoltage: item['batteryVoltage'] ? item['batteryVoltage'] : 'N/A',
          encoder: (item['encoder'] == 1) ? 'ON' : (item['encoder'] == 0) ? 'OFF' : 'N/A',
          realy2: (item['realy2'] == 1) ? 'ON' : (item['realy2'] == 0) ? 'OFF' : 'N/A',
          siren: (item['siren'] == 1) ? 'ON' : (item['siren'] == 0) ? 'OFF' : 'N/A',
          router: (item['router'] == 1) ? 'ON' : (item['router'] == 0) ? 'OFF' : 'N/A',
          temperature: item['temperature'] ? item['temperature'] : 'N/A',
          reason: item['reason'] ? item['reason'] : 'N/A',
          devDate: item['devDate'] ? item['devDate'] : 'N/A',
        });
        }
      }
    }
    return formattedData;
  }

  private formatMdcExcelData() {
    let data = this.mdcData;
    let searchTerm = this.filterMDCValue ? this.filterMDCValue : '';
    if(searchTerm){
      searchTerm= searchTerm.toLowerCase();
    }
    let formattedData: Array<any> = [];
    if (data && data.length > 0) {
      for (let i = 0; i < data.length; i++) {
        let item = data[i];
       if(item['potentialId'].toLowerCase().includes(searchTerm)|| 
          item['siteName'].toLowerCase().includes(searchTerm) ||
          item['deviceName'].toLowerCase().includes(searchTerm) ||
          item['siteUnitId'].toLowerCase().includes(searchTerm) ||
          item['deviceId'].toLowerCase().includes(searchTerm) ||
          item['deviceUqId'].toLowerCase().includes(searchTerm) ||
          item['accId'].toLowerCase().includes(searchTerm) ||
          item['siteType'].toLowerCase().includes(searchTerm)){
          formattedData.push({
            potentialId: item['potentialId'] ? item['potentialId'] : 'N/A',
            siteName: item['siteName'] ? item['siteName'] : 'N/A',
            type: item['type'] ? item['type'] : 'N/A',
            deviceName: item['deviceName'] ? item['deviceName'] : 'N/A',
            siteType: item['siteType'] ? item['siteType'] : 'N/A',
            status: item['status'] ? item['status'] : 'N/A',
            siteUnitId: item['siteUnitId'] ? item['siteUnitId'] : 'N/A',
            solarEnabled: item['solarEnabled'] == true ? 'true' :  'false',
            deviceId: item['deviceId'] ? item['deviceId'] : 'N/A',
            deviceUqId: item['deviceUqId'] ? item['deviceUqId'] : 'N/A',
            deviceType: item['deviceType'] ? item['deviceType'] : 'N/A',
            accId: item['accId'] ? item['accId'] : 'N/A'
          })
        }
      }
    }
    return formattedData;
  }

  showdeviceData = (data) => {
    this.deviceInfoDataObj = data;
    this.displayStyle1 = 'block';
  }

  showMDCData(data){
    this.spinner.activate()
    this.restService.getRequest(AppSettings.MDC_DEVICES,'').subscribe((dt)=>{
      this.spinner.deactivate()
      this.mdcMetadata = dt.filter(x=> x.deviceUqId == data.deviceUqId);
      this.mdcMetadata = this.mdcMetadata[0];
      let ele = document.getElementById('myModal4') as HTMLElement;
      if(ele){
        ele.style.display = 'block';
      }
    })
  }

  closeMdcdata(){
    let ele = document.getElementById('myModal4') as HTMLElement;
    if(ele){
      ele.style.display = 'none';
    }
  }


  closePopup = () => {
    this.displayStyle1 = 'none';
  };
}
